import type { PriceId } from '@iheartjane/types';
import get from 'lodash-es/get';

// eslint-disable-next-line no-restricted-imports
import type { MenuProduct } from '@jane/shared/models';

export function firstAvailablePriceIdFromFilters({
  menuProduct,
  appliedFilters,
  defaultValue,
}: {
  appliedFilters: string[];
  defaultValue: PriceId;
  menuProduct: MenuProduct;
}): PriceId {
  const applicablePriceId = appliedFilters
    ?.find((priceId) => get(menuProduct, `price_${priceId.replace(' ', '_')}`))
    ?.replace(' ', '_');
  return applicablePriceId ? (applicablePriceId as PriceId) : defaultValue;
}
